const rankingItems = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子', heat: '🔥🔥🔥', views: '128.5万', trend: 'up', change: '+12' },
  { rank: 2, title: '电商主播涉嫌虚假宣传被立案', heat: '🔥🔥🔥', views: '96.2万', trend: 'up', change: '+8' },
  { rank: 3, title: '知名导演被曝剧组潜规则', heat: '🔥🔥', views: '87.3万', trend: 'up', change: '+23' },
  { rank: 4, title: '流量明星代言品牌集体解约', heat: '🔥🔥', views: '74.8万', trend: 'up', change: '+5' },
  { rank: 5, title: '综艺节目剪辑争议持续发酵', heat: '🔥🔥', views: '63.1万', trend: 'down', change: '-3' },
  { rank: 6, title: '网红情侣分手互撕最新进展', heat: '🔥', views: '55.6万', trend: 'up', change: '+15' },
  { rank: 7, title: '某社交平台大规模删帖事件', heat: '🔥', views: '48.9万', trend: 'new', change: 'NEW' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
          <i className="ri-medal-line text-primary-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
          吃瓜热度榜单
        </h2>
        <p className="text-sm text-foreground-500 mb-8">51吃瓜网今日吃瓜实时热度排行，看看大家都在围观什么</p>

        <div className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden">
          <div className="grid grid-cols-12 gap-2 px-5 py-3 bg-background-100 text-xs font-medium text-foreground-500">
            <span className="col-span-1">排名</span>
            <span className="col-span-6">话题</span>
            <span className="col-span-2 text-center">热度</span>
            <span className="col-span-2 text-center">围观</span>
            <span className="col-span-1 text-center">趋势</span>
          </div>
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="grid grid-cols-12 gap-2 px-5 py-3.5 border-t border-background-200/40 items-center hover:bg-background-50/80 transition-colors duration-150 cursor-pointer"
            >
              <span className={`col-span-1 font-heading text-base font-bold ${
                item.rank <= 3 ? 'text-primary-500' : 'text-foreground-400'
              }`}>
                {item.rank <= 3 ? (
                  <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary-100 text-primary-600 text-xs font-bold">{item.rank}</span>
                ) : (
                  item.rank
                )}
              </span>
              <span className="col-span-6 text-sm text-foreground-800 font-medium truncate">{item.title}</span>
              <span className="col-span-2 text-center text-xs">{item.heat}</span>
              <span className="col-span-2 text-center text-xs text-foreground-400">{item.views}</span>
              <span className={`col-span-1 text-center text-xs font-medium whitespace-nowrap ${
                item.trend === 'up' ? 'text-accent-600' : item.trend === 'new' ? 'text-primary-500' : 'text-foreground-400'
              }`}>
                {item.trend === 'up' && <i className="ri-arrow-up-line w-3 h-3 inline-flex items-center justify-center align-middle"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-line w-3 h-3 inline-flex items-center justify-center align-middle"></i>}
                {item.change}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}